module.exports = __webpack_public_path__ + "img/img-4.b7a61a68.jpg";